import React from 'react';
import SortableHeader from './SortableHeader';

const VariablesTableHeader = ({
  isSingleRow,
  sortColumn,
  sortDirection,
  onSort,
  canResize,
  startColumnResize,
  sentinelRef,
  headerRef,
  stuck,
}) => {
  const resizeHandle = (label, resizeAfterIndex) =>
    canResize && resizeAfterIndex != null ? (
      <div
        className="variables-panel__col-resize"
        role="separator"
        aria-orientation="vertical"
        aria-label={`Resize ${label} column`}
        title="Drag to resize columns"
        onPointerDown={(e) => startColumnResize(resizeAfterIndex, e)}
      />
    ) : null;

  const headerCell = (column, label, resizeAfterIndex = null) => (
    <div className="variables-panel__col-shell" key={column}>
      <SortableHeader
        column={column}
        label={label}
        sortColumn={sortColumn}
        sortDirection={sortDirection}
        onSort={onSort}
      />
      {resizeHandle(label, resizeAfterIndex)}
    </div>
  );

  const compactHeaderCell = (label, resizeAfterIndex = null) => (
    <div className="variables-panel__col-shell" key={label}>
      <div className="variables-panel__col">{label}</div>
      {resizeHandle(label, resizeAfterIndex)}
    </div>
  );

  return (
    <>
      {!isSingleRow && (
        <div
          ref={sentinelRef}
          className="variables-panel__sticky-sentinel"
          aria-hidden="true"
        />
      )}
      {isSingleRow ? (
        <div className="variables-panel__table-header variables-panel__table-header--compact">
          <div className="variables-panel__col variables-panel__col--color" />
          {compactHeaderCell('Variable', 0)}
          {compactHeaderCell('Type', 1)}
          {compactHeaderCell('Value', 2)}
          {compactHeaderCell('Description', 3)}
          {compactHeaderCell('Scope', null)}
          <div className="variables-panel__col variables-panel__col--actions" />
        </div>
      ) : (
        <div
          ref={headerRef}
          className={`variables-panel__table-header${stuck ? ' is-stuck' : ''}`}
        >
          <div className="variables-panel__col variables-panel__col--drag" />
          <div className="variables-panel__col variables-panel__col--color" />
          {headerCell('name', 'Variable', 0)}
          {headerCell('type', 'Type', 1)}
          {headerCell('value', 'Value', 2)}
          {headerCell('description', 'Description', 3)}
          {headerCell('scope', 'Scope', null)}
          <div className="variables-panel__col variables-panel__col--actions" />
        </div>
      )}
    </>
  );
};

export default VariablesTableHeader;
